import React from "react";

import { DetectorQueryInput } from "./DetectorQueryInput";

export interface CreateTextRecognitionProps {
  queryValue: string;
  handleChangeValue: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  setHasErrors?: (hasErrors: boolean) => void;
}

export function CreateTextRecognition({ queryValue, handleChangeValue, setHasErrors }: CreateTextRecognitionProps) {
  return (
    <DetectorQueryInput
      queryValue={queryValue}
      handleChangeValue={handleChangeValue}
      setHasErrors={setHasErrors}
      defaultValue="Read all visible text in the image."
      hint="Try formatting your query to request specific text in an image. For example “What is the serial number on the silver label?” or “What is the person's name on the ID card?”"
    />
  );
}
